<template>
    <div class="revision-info">
        <div>
            <span class="label">{{$t('message.horseEdit.history.revision.author')}}:  </span>
            <span>{{username}}</span>
        </div>

        <div>
            <span class="label">{{$t('message.horseEdit.history.revision.date')}}:  </span>
            <span>{{timestamp}}</span>
        </div>
    </div>
</template>

<script>

export default {
    name: "RevisionInfo",
    components: {
    },

    data() {
        return {
        };
    },

    props: {
        username: null,
        timestamp: null,
    },

    methods: {
    },

};
</script>



<style scoped lang="scss">
    .revision-info {
        color: var(--text-color);
    }
    .label {
        font-weight: 600;
        text-transform: uppercase;
    }
</style>
